import styled from "styled-components";

export const Container = styled.div`
  font-size: 1.125rem;
  // FIXME: 피그마에 color 타입 지정되면 변경하기
  color: #333333;
`;

export const Title = styled.h1`
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding: 1.25rem;

  font-size: 1.5rem;
  font-weight: 700;
  color: #262626;
`;

export const Contents = styled.div`
  padding: 1.25rem;
`;

export const ItemTitle = styled.h2`
  margin: 1.25rem 0 0.625rem 0;
  font-size: 1rem;
  font-weight: 600; // FIXME: 500 적용해도 안 두꺼워짐
  color: #010101;
`;
